{
  "fr": {
    "imagePicker": {
      "title": "Ajouter une image",
      "replaceTitle": "Remplacer l'image",
      "searchPlaceholder": "Rechercher des images...",
      "tabLabelWithCount": "{label} ({count})",
      "resultCount": "Aucun résultat | {count} résultat | {count} résultats",
      "resultCountCapped": "Plus de {count} résultats",
      "cancel": "Annuler",
      "confirm": "Utiliser",
      "empty": {
        "headline": "Aucun résultat pour « {query} »",
        "subline": "Essayez un autre terme de recherche"
      },
      "error": {
        "headline": "Les images n'ont pas pu être chargées.",
        "retry": "Réessayer"
      },
      "generate": {
        "tabLabel": "Générer une image",
        "headline": "Crée une image",
        "promptPlaceholder": "Décris ton image",
        "cta": "Créer l'image",
        "ctaRegenerate": "Recréer l'image",
        "generating": "Création de l'image en cours",
        "generated": "Image créée et sélectionnée",
        "resultSelect": "Sélectionner l'image générée",
        "modelLabel": "Choisir le modèle IA",
        "uploadError": "L'image n'a pas pu être prise en compte. Veuillez réessayer.",
        "limitReached": "Tu as atteint ta limite quotidienne d'images IA."
      },
      "upload": {
        "tabLabel": "Télécharger",
        "dropTitle": "Glissez-déposez ici ou {select}.",
        "dropTitleSelect": "Sélectionner une image",
        "success": "Fichier téléchargé avec succès",
        "remove": "Supprimer l'image",
        "errors": {
          "wrongFormat": "Ce format de fichier n'est pas pris en charge. Formats autorisés : {formats}",
          "failed": "L'image n'a pas pu être téléchargée. Veuillez réessayer."
        }
      },
      "stock": {
        "tabLabel": "Images libres de droits",
        "source": "Source :",
        "imageTypeLegend": "Type d'image",
        "categoryLimit": "Maximum {max} catégories simultanément.",
        "uploadError": "L'image n'a pas pu être reprise. Veuillez réessayer.",
        "categories": {
          "nature": "Nature",
          "animals": "Animaux",
          "research": "Recherche",
          "mathematics": "Mathématiques",
          "technology": "Technique",
          "reading": "Lecture",
          "creativity": "Créativité",
          "music": "Musique",
          "sports": "Sport",
          "nutrition": "Alimentation",
          "classroom": "Salle de classe",
          "teamwork": "Travail d'équipe",
          "climate": "Climat",
          "space": "Espace",
          "summer": "Été",
          "spring": "Printemps",
          "autumn": "Automne",
          "winter": "Hiver",
          "easter": "Pâques",
          "christmas": "Noël"
        }
      },
      "library": {
        "tabLabel": "Mon espace de stockage",
        "selectError": "L'image n'a pas pu être importée. Veuillez réessayer.",
        "imageAlt": {
          "manual": "Image téléchargée",
          "ai": "Image créée par IA"
        },
        "empty": {
          "headline": "Vous n'avez pas encore d'images",
          "subline": "Vos images téléchargées et créées par IA apparaissent ici."
        }
      }
    }
  }
}
